// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Modal0 from "../common/Modal0.bs.js";
import * as Tooltip from "common/src/components/Tooltip.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import HelpOutline from "@mui/icons-material/HelpOutline";

var cols = [
  StatsTable2.col(false, undefined, (function (param, param$1) {
          return param$1.t("Headliner");
        }), "!pl-6", (function (param, param$1, param$2) {
          var traitId = param[0];
          return React.createElement("div", {
                      className: "flex items-center gap-1"
                    }, React.createElement(TraitImage.PlainIcon.make, {
                          traitId: traitId,
                          size: 28
                        }), param$2.traitsT(traitId));
        }), "!pl-6", undefined, undefined, (function (param, param$1, param$2) {
          return param$2.traitsT(param[0]);
        }), undefined, 160, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Play Rate");
        }), undefined, (function (param, param$1, param$2) {
          return Global.formatPct2(undefined, Global.f(param[1]) / Global.f(param$1[0]));
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1];
        }), undefined, 100, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Place");
        }), undefined, (function (param, param$1, param$2) {
          return Global.toFixed(undefined, param[2]);
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[2];
        }), undefined, 84, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Delta");
        }), "!pr-6", (function (param, param$1, param$2) {
          var delta = (param[2] - param$1[1]) / (1 - Global.f(param[1]) / Global.f(param$1[0]));
          return Global.toFixed(undefined, delta);
        }), "!pr-6", undefined, undefined, (function (param, param$1, param$2) {
          return (param[2] - param$1[1]) / (1 - Global.f(param[1]) / Global.f(param$1[0]));
        }), undefined, 84, undefined, undefined),
  StatsTable2.col(true, true, (function (param, param$1) {
          return param$1.t("Top 4");
        }), undefined, (function (param, param$1, param$2) {
          return Global.formatPct2(undefined, param[3]);
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[3];
        }), undefined, 84, undefined, undefined),
  StatsTable2.col(true, true, (function (param, param$1) {
          return param$1.t("Won");
        }), undefined, (function (param, param$1, param$2) {
          return Global.formatPct2(undefined, param[4]);
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[4];
        }), undefined, 84, undefined, undefined)
];

function Tc2HeadlinersTab(Props) {
  var group = Props.group;
  var extraTraits = group.extraTraits;
  if (extraTraits === undefined) {
    return null;
  }
  var keyFn = React.useCallback((function (param) {
          return param[0];
        }), []);
  var headliners = React.useMemo((function () {
          return Belt_Array.keep(extraTraits, (function (param) {
                        var c = param[1];
                        if (c > 100) {
                          return Global.f(c) / Global.f(group.count) > 0.01;
                        } else {
                          return false;
                        }
                      }));
        }), [extraTraits]);
  return React.createElement("div", undefined, React.createElement("h4", {
                  className: "p-3 text-lg flex items-center gap-1"
                }, "Headliner Traits", React.createElement(Tooltip.make, {
                      title: React.createElement("div", {
                            className: "flex flex-col gap-2"
                          }, React.createElement("div", undefined, "Headliner traits that do not increase trait's tier are not tracked.")),
                      children: React.createElement(HelpOutline, {
                            fontSize: "small"
                          })
                    })), React.createElement("div", {
                  className: "mx-[-20px]"
                }, React.createElement(StatsTable2.make, {
                      cols: cols,
                      data: headliners,
                      context: [
                        group.count,
                        group.place
                      ],
                      keyFn: keyFn,
                      top: "tm40",
                      defaultSortIdx: 1,
                      scrollEl: [
                        Modal0.modalScrollEl(),
                        0
                      ]
                    })));
}

var make = Tc2HeadlinersTab;

export {
  cols ,
  make ,
  
}
/* cols Not a pure module */
